import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/`,
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const { token } = getState().auth;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      // headers.set('Content-Type', `application/json`);
      // headers.set('Access-Control-Allow-Origin', '*');
      return headers;
    },
  }),
  tagTypes: [
    'user',
    'Notification',
    'Bookmarks',
    'TopicById',
    'SellingItems',
    'SubscriptionDetail',
    'previewEmailTags',
    'regionalSetting',
    'shopSettings',
    'PromotionalBanner',
    'preLiveChecks',
    'templateData',
    'dashboardMetrics',
    'adminDashboardUserDetails',
    'OrderDetails',
  ],
  endpoints: () => ({}), // <= This line is Mandatory even if empty
});

export const prodApiSlice = createApi({
  reducerPath: 'prodapi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_PROD_URL}/`,
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const { token } = getState().auth;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      // headers.set('Content-Type', `application/json`);
      // headers.set('Access-Control-Allow-Origin', '*');
      return headers;
    },
  }),
  endpoints: () => ({}), // <= This line is Mandatory even if empty
});

export const discourseApiSlice = createApi({
  reducerPath: 'webapi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_DISCOURSE_URL}`,
    prepareHeaders: (headers) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      headers.set(
        'Api-Username',
        `${process.env.REACT_APP_API_DISCOURSE_USER_NAME}`,
      );
      headers.set('Api-Key', `${process.env.REACT_APP_API_DISCOURSE_API_KEY}`);
      headers.set('Content-Type', `application/json`);
      // headers.set('Access-Control-Allow-Origin', '*');
      return headers;
    },
  }),
  endpoints: () => ({}), // <= This line is Mandatory even if empty
});
